import { IFavoriteRecommendationOfferSchema } from '../repositories/favorites/entities/get_favorites_recommendations/FavoriteRecommendationOfferSchema';
import type { TOfferAnalyticsData, TRecommendation } from '../types/recommendation';

export function prepareRecommendations(rawRecommendations: IFavoriteRecommendationOfferSchema[]): TRecommendation[] {
  return rawRecommendations.map(
    (
      {
        analyticsData = {},
        dealType,
        discount,
        entityId,
        entityType,
        imageUrl,
        info,
        isFavorite,
        offerType,
        text,
        title,
        underground,
        url,
      },
      index,
    ) => ({
      description: text,
      href: url,
      imageUrl: imageUrl || '',
      title,
      info,
      analyticsData: {
        offerId: entityId,
        type: 'offer',
        ...analyticsData,
        products: [
          {
            id: entityId,
            offerType: 'offer',
            position: index + 1,
          },
        ],
      } as TOfferAnalyticsData,
      offerId: entityId,
      underground,
      isFavorite: isFavorite || false,
      dealType,
      offerType,
      entityType,
      discount,
    }),
  );
}
